module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921095649_T.40af04b0.jpg";